<div class="dx-field" style="width: 515px;">
    <div class="dx-field-value">
      <dx-tag-box #multiSelectTagBox
      [items]="dataSource" 
      [searchEnabled]="true"
      displayExpr="name"
      valueExpr="id"
      (onValueChanged)="onValueChanged($event)" 
      [(ngModel)]="value"
      [disabled] ="disabled"
      [(required)]="isRequired"
      [noDataText]="isNotNoDataText ? 'Please enter atleast 2 characters' : 'No data to display'" 
      (onInput)="onMultiSelectBoxInput($event)" 
      (onFocusOut)="onOutsideMultiSelectBoxClick($event)">
      </dx-tag-box>
    </div>
  </div>

